import buildSizeMap from 'lib/buildSizeMap';

import type { BreakpointMap } from 'types/BreakpointMap';
import type { CreativeSizeMap } from 'types/CreativeSizeMap';

/**
 * Builds the responsive mapping for the ad slot sizes according to the sites breakpoints
 * @private
 */
export default function buildResponsiveSizeMap(
	breakpoints: BreakpointMap,
	sizeMapping: CreativeSizeMap,
) {
  const { sizeMapping: SizeMappingBuilder } = window.googletag;
	
  const mapping = SizeMappingBuilder();

	Object.keys(sizeMapping).forEach((mappedSize: string) => {
		const sizeBreakpoint = breakpoints[mappedSize];
		if (sizeBreakpoint) {
			mapping.addSize(sizeBreakpoint, buildSizeMap(sizeMapping[mappedSize]));
		}
	});

  return mapping.build();
}
